
import * as variables from './variables.js';

import 'window.requestanimationframe';
import 'es6-promise/auto';
import 'whatwg-fetch';

import {Analytics} from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import Forms from './component/Forms';
Forms.init();

// NOTE: Colorbox must see jQuery on the window in order to work properly
import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;

import JSFAjaxJQueryAdapter from '@plaudit/jsf-ajax-adapters/dist/jQuery';
JSFAjaxJQueryAdapter.init();

import MainMenu from './component/MainMenu';
new MainMenu({
	menu 			: '#menu',
	menuTarget 		: '.menu__inner',
	nodeTarget_slidable : '.childWrap--L2',
	nodeTrigger 	: '.node--hasDropdown > a',
	headTarget 		: '.childWrap__heading',
	triggers 		: '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
	triggerEvent 	: 'click',
	collapsable: {
		duration: 400
	},
	styleClass: {
		setup 			: 'hasMenuSetup',
		menuOpen 		: 'hasMenuOpen',
		nodeOpen 		: 'isOpen',
		backWrap 		: 'childWrap__back'
	}
});

import StickyItems from './component/StickyItems';
new StickyItems();

import initTabs from './component/TabContent';
initTabs();

// Pikaday is causing annoying issue where you can't use the left arrow in any form fields (https://github.com/Pikaday/Pikaday/pull/710)
// Consider changing date fields to use HTML5 Date Picker
import DatePicker from './component/DatePicker';
new DatePicker();

import EventPicker from './component/EventPicker';
new EventPicker();

import initAddClass from './component/AddClassOnScroll';
initAddClass();

//import initParallax from './component/Parallax';
//initParallax();

import ProductSearch from './component/ProductSearch';
new ProductSearch();

import './component/Slide';

// @ts-ignore
var Accordion = require('./component/Accordion.js');
var faqsAccordion = new Accordion({
	scope: '.faqs'
});
faqsAccordion.activate();




/* Silky smooth scrolling */
import SmoothScroll from './component/SmoothScroll';
const mySmoothScroll = new SmoothScroll();
const setUpSmoothScroll = () => {
	mySmoothScroll.add('.sizeChart a[href*="#"]:not([onclick])', {
		duration: 1200,
		easing: 'easeOutCirc',
		offset: 50
	});
};
setUpSmoothScroll();
$(document).on('jsfAjaxAlways', setUpSmoothScroll);


/* This lightbox is being used for the Add and Edit buttons on the Order Form  */
import Lightbox from './component/Lightbox/Lightbox';
const lightbox = new Lightbox({
	styleClass: 'lightbox--orderForm'
});

$('.orderForm .btn--edit, .orderForm .btn--add, .product .btn--add').on('click', function(event) {
	const href = (this as HTMLAnchorElement).href;
	$.ajax({async: false, url: href, success: function(data) {
		const newContent = $(data).find('.lightboxContent');
		const contentElement = $(lightbox.getContentElement());
		contentElement.empty(); /* Clears lightbox before populating - otherwise form will repeat */
		contentElement.append(newContent);
	}});
	lightbox.open();
	event.preventDefault();
});

import initLikeMarkerSupport from "./component/LikeMarkerHandler";
initLikeMarkerSupport();

import initTooltips from './component/Tooltip';
initTooltips();